import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";

import Breadcrumb from "../../components/Breadcrumb";
import AllGarageLayer from "../../components/garages/AllGarageLayer";

const AllGaragePage = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>
        {/* Breadcrumb */}
        <Breadcrumb
          routePath="/all-garages"
          routeName="Home"
          title="All Garages"
        />

        {/* TableDataLayer */}
        <AllGarageLayer />
        {/* <AlertLayer/> */}
      </MasterLayout>
    </>
  );
};

export default AllGaragePage;
